import { FC, useEffect, useRef, useState } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { IStyledSelectCustomRawProps } from './interface';
import {
  ArrowIconContainer,
  OptionsCustomContainer,
  SelectCustomContainer,
  Error,
} from './style';

const StyledSelectCustomRaw: FC<IStyledSelectCustomRawProps> = (props) => {
  const [openOptions, setOpenOptions] = useState(false);
  const selectRef = useRef<HTMLDivElement | null>(null);

  const toggleOptions = () => {
    setOpenOptions(!openOptions);
  };

  // Função para lidar com cliques fora do componente
  const handleClickOutside = (event: MouseEvent) => {
    if (
      selectRef.current &&
      !(
        event.target instanceof Node && selectRef.current.contains(event.target)
      )
    ) {
      setOpenOptions(false);
    }
  };

  useEffect(() => {
    // Adicione um event listener de clique no documento quando o componente montar
    document.addEventListener('click', handleClickOutside);

    // Remova o event listener quando o componente for desmontado
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleSelectOption = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    props.setSelectValue(event.currentTarget.id);
    setOpenOptions(false);
  };

  return (
    <SelectCustomContainer {...props} ref={selectRef} openOptions={openOptions}>
      <input
        type="text"
        value={props.selectValue}
        className="selected-option"
        placeholder={props.placeHolder}
        onClick={toggleOptions}
        readOnly
      />
      <ArrowIconContainer
        {...props}
        openOptions={openOptions}
        onClick={() => setOpenOptions(!openOptions)}
      >
        {props.arrowIcon || (
          <MdOutlineKeyboardArrowDown size={props.arrowIconSize} />
        )}
      </ArrowIconContainer>
      {openOptions && (
        <OptionsCustomContainer {...props}>
          <div
            className="option"
            onClick={() => {
              props.setSelectValue('');
              setOpenOptions(false);
            }}
          >
            {props.placeHolderOnList}
          </div>
          {props.optionsList.map((item, index) => (
            <div
              className="option"
              id={item.id}
              key={String(index) + String(item.id)}
              onClick={handleSelectOption}
            >
              {item.value}
            </div>
          ))}
        </OptionsCustomContainer>
      )}
      {props.error && props.errorMessage !== '' && (
        <Error>{props.errorMessage}</Error>
      )}
    </SelectCustomContainer>
  );
};

export default StyledSelectCustomRaw;
